import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { ReportConfigurationDTO } from './report-config.dto';
//import { AuthService } from './authservice.service';

@Injectable({
  providedIn: 'root'
})
export class PowerBIService {

  constructor(private http: HttpClient) { }

  getReportEmbedToken(reportname): Observable<any> {
    let apiUrl = environment.baseAPIURL + `GetReportEmbedInfo?report=${reportname}`;
    return this.http.get(apiUrl);
  }

  getAllReports(): Observable<ReportConfigurationDTO[]> {
    let apiUrl = environment.baseAPIURL + `GetAllReports`;
    return this.http.get<ReportConfigurationDTO[]>(apiUrl);
  }

  getReportURL(reportTagName: string) {

    let has2023Report = false;
    const reportLinks: ReportConfigurationDTO[] = JSON.parse(sessionStorage.getItem('reportLinks'));
    //check if reportLinks array contains any report with tag containing '2023' where IsActive is true
    if (reportLinks && reportLinks.some(report => report.tag.toLowerCase().includes('2023') && report.isActive)) {
      has2023Report = true;
    }
    
    const LOADREPORT_V1 = '/loadreportv1/', LOADREPORT = '/loadreport/', LOADREPORT_V2 = '/loadreportv2/';
    let loadReportComponentName: string;
    if (reportTagName.toLocaleLowerCase().indexOf('2023') != -1) {
      loadReportComponentName = LOADREPORT_V2;
    }
    else if (reportTagName.toLocaleLowerCase().indexOf('v1') != -1) {
      loadReportComponentName = LOADREPORT_V1;
    }
    else if (has2023Report) {
      loadReportComponentName = LOADREPORT_V2;
    }
    else {
      loadReportComponentName = LOADREPORT;
    }
   

    return `${loadReportComponentName}${reportTagName}`;
  }
  
}
